import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const SwiperComponent = ({ Speed, slidesContent ,  breakpointsConfig = {} }) => {
  let swiperInstance = null; // To store Swiper instance
  const handleSlideTouchStart = (swiper) => {
    // Apply scaling when drag starts
    const slides = swiper.slides;
    slides.forEach((slide) => {
      slide.style.transition = "transform 0.2s ease"; // Smooth transition
      slide.style.transform = "scale(0.85)"; // Scale down to 0.85
    });
  };

  const handleSlideTouchEnd = (swiper) => {
    // Reset scaling when drag ends
    const slides = swiper.slides;
    slides.forEach((slide) => {
      slide.style.transition = "transform 0.2s ease"; // Smooth transition
      slide.style.transform = "scale(1)"; // Reset scale to 1
    });
  };
  return (
    <div
      className="swiper-container"
      onMouseEnter={() => {
        if (swiperInstance) swiperInstance.autoplay.stop();
      }}
      onMouseLeave={() => {
        if (swiperInstance) swiperInstance.autoplay.start();
      }}
    >
      <Swiper
        className="speakers"
        modules={[Autoplay]}
        loop={true}
        autoplay={{
          delay: 0, // Continuous scrolling without pause
          disableOnInteraction: false, // Keep autoplay running even on interaction
        }}
        breakpoints={breakpointsConfig}
        speed={Speed} // Adjust speed for smooth motion
        onSwiper={(swiper) => {
          swiperInstance = swiper; // Save the Swiper instance
        }}
        onTouchStart={(swiper) => handleSlideTouchStart(swiper)} // Detect start of drag
        onTouchEnd={(swiper) => handleSlideTouchEnd(swiper)} // Detect end of drag
      >
        {slidesContent} {/* Render dynamic slides content */}
      </Swiper>
    </div>
  );
};

export default SwiperComponent;
